import { ONE_O_ONE_C_FILTER } from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getKhattabatFilterStore from "../../../../stores/khattabat-stores/filter-store";
import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";
import { TEt3PickerMultipleValue } from "../../../../TypesNEW";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ApplyButton from "./ApplyButton";
import Title from "./Title";
import { E_CLIENT_PAGE } from "../../../../Types";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import AiFilter from "./ai-filter";
import getKhattabat101CGeneralStore from "../../../../stores/khattabat-stores/101c-stores/101c-general-store";

const Filter = withLiteObserverAndTheme(() => {
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();

  if (isAiKhattaba) {
    return <AiFilter />;
  }

  const shouldShow =
    getKhattabat101CGeneralStore().getClientPageType.get() ===
    E_CLIENT_PAGE.ALL;

  return !shouldShow ? (
    <ET3Div
      width={755}
      height={150}
      alignItems={"space-between"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"flex-start"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    />
  ) : (
    <ET3Div
      width={755}
      height={150}
      alignItems={"space-between"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"flex-start"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Title />
      <Et3Margin top={10} bottom={10} left={0} right={0} />
      <ET3Div
        width={755}
        height={100}
        alignItems={"flex-start"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"space-between"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("FILTERS")}
          options={ONE_O_ONE_C_FILTER}
          value={getKhattabatFilterStore().filterSelectedTypes.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatSelectsStore().initializeAndClearMarksStateWithClients(
              "clientPage"
            );
            getKhattabatFilterStore().setFilterSelectedTypes(value);
          }}
          isMultiple={true}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <ApplyButton />
      </ET3Div>
    </ET3Div>
  );
});

export default Filter;
